import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import SwitchUser from '@/modules/profile/SwitchUser'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useEffect } from 'react'

export default function SwitchUserPage() {
  const dispatch = useAppDispatch()
  const headerLeftItems = useWebBackButton('/profile')
  const currentUser = useAppSelector(state => state.currentUser.user)

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
  }, [dispatch])

  if (!currentUser) {
    return null
  }

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <SwitchUser currentUser={currentUser} />
    </>
  )
}
